import { Token, Pair, ChainId } from '@pancakeswap/sdk'
import { isAddress } from 'utils'

const getLpAddress = (token1: string | Token, token2: string | Token) => {
  console.log('[getLpAddress] Called with:', { token1, token2 })
  
  let token1AsTokenInstance = token1
  let token2AsTokenInstance = token2
  if (!token1 || !token2) {
    console.log('[getLpAddress] Missing token addresses, returning null')
    return null
  }
  
  // Use the current chain ID from environment or fallback to MAINNET
  const currentChainId = process.env.NEXT_PUBLIC_CHAIN_ID ? parseInt(process.env.NEXT_PUBLIC_CHAIN_ID, 10) : ChainId.MAINNET
  console.log('[getLpAddress] Using chain ID:', currentChainId)
  
  if (typeof token1 === 'string' || token1 instanceof String) {
    const checksummedToken1Address = isAddress(token1)
    console.log('[getLpAddress] Token1 checksummed address:', checksummedToken1Address)
    if (!checksummedToken1Address) {
      console.log('[getLpAddress] Invalid token1 address, returning null')
      return null
    }
    token1AsTokenInstance = new Token(currentChainId, checksummedToken1Address, 18)
  }
  if (typeof token2 === 'string' || token2 instanceof String) {
    const checksummedToken2Address = isAddress(token2)
    console.log('[getLpAddress] Token2 checksummed address:', checksummedToken2Address)
    if (!checksummedToken2Address) {
      console.log('[getLpAddress] Invalid token2 address, returning null')
      return null
    }
    token2AsTokenInstance = new Token(currentChainId, checksummedToken2Address, 18)
  }
  
  const pairAddress = Pair.getAddress(token1AsTokenInstance as Token, token2AsTokenInstance as Token)
  console.log('[getLpAddress] Generated pair address:', pairAddress)
  return pairAddress
}

export default getLpAddress
